import DownloadButton from './downloadButton.view';

export default DownloadButton;
